import { render, staticRenderFns } from "./IconView.vue?vue&type=template&id=06123cce&scoped=true"
import script from "./IconView.vue?vue&type=script&lang=js"
export * from "./IconView.vue?vue&type=script&lang=js"
import style0 from "./IconView.vue?vue&type=style&index=0&id=06123cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06123cce",
  null
  
)

export default component.exports